// Filter groups of the jobs page. `name` is the query param sent to the jobs endpoint.
// `checkbox` groups allow multiple values and are sent comma separated, `radio` groups a single one.
export const JOB_FILTERS = [
	{
		name: 'employment_type',
		label: 'Employment Type',
		type: 'radio',
		options: [
			{ label: 'Full-Time', value: 'full_time' },
			{ label: 'Part-Time', value: 'part_time' }
		]
	},
	{
		name: 'job_mode',
		label: 'Job Mode',
		type: 'checkbox',
		options: [
			{ label: 'Onsite', value: 'onsite' },
			{ label: 'Hybrid', value: 'hybrid' },
			{ label: 'Remote', value: 'remote' }
		]
	},
	{
		name: 'job_level',
		label: 'Job Level',
		type: 'checkbox',
		options: [
			{ label: 'Senior', value: 'senior' },
			{ label: 'Mid-Level', value: 'mid_level' },
			{ label: 'Junior', value: 'junior' },
			{ label: 'Internship', value: 'internship' }
		]
	},
	{
		name: 'date_posted',
		label: 'Job Post Date',
		type: 'radio',
		options: [
			{ label: 'Today', value: 'today' },
			{ label: 'Last 3 days', value: 'last_3_days' },
			{ label: 'Last week', value: 'last_week' },
			{ label: 'Last month', value: 'last_month' }
		]
	}
];
